<template>
    <div class="phoneFee">
        <!-- 分账管理-话费账单 -->
        <!-- 标题 -->
        <div class="titleBox flex-row ite-c">
            <b>{{topTitle.title}}</b>
            <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
            <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
        </div>

        <!-- 筛选条件 -->
        <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
            <template slot="otherCom">

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.code"
                            placeholder="输入分账ID"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.memberName"
                            placeholder="输入分账对象"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <!-- <el-form-item>
                    <el-select  v-model="searchForm.params.status" 
                                placeholder="选择状态"
                                clearable filterable 
                    >
                        <el-option  v-for="item in statusOptions" 
                                    :key="item.id" 
                                    :label="item.status" 
                                    :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item>
                    <el-date-picker
                        v-model="searchForm.params.month"
                        type="month"
                        placeholder="选择年月"
                        value-format="yyyy-MM"
                        @change="yearMonthChange"
                        :clearable="false"
                    >
                    </el-date-picker>
                </el-form-item>

            </template>
        </sr-filter>

        <!-- 表格 -->
        <!-- <div class="botTable boxs tableTheadGray" style="min-width:753px"> -->
        <div class="botTable boxs tableTheadGray">
            <div class="tableTop">
                <span class="top_le">{{showYear}}/{{showMonth}}-话费账单</span>
                <span class="top_ri flex_h_hR_vC">
                    <span>{{showYear}}年{{showMonth}}月实际分账：</span>
                    <span style="font-size:15px; color:#FA6241;"> {{monthTotal.actualTotal}} </span>
                    <span>&nbsp;元，共&nbsp;</span>
                    <span style="color:#333333;"> {{monthTotal.actualCount}} </span>
                    <span style="margin-right:20px;">&nbsp;笔</span>

                    <span>截止当前累计分账：</span>
                    <span style="font-size:15px; color:#FA6241;"> {{monthTotal.cumulativeTotal}} </span>
                    <span>&nbsp;元，共&nbsp;</span>
                    <span style="color:#333333;"> {{monthTotal.cumulativeCount}} </span>
                    <span style="margin-right:20px;">&nbsp;笔</span>

                    <button class="butStyle pinkBtn exportBtn" @click="tableExport">
                        <i class="exportIcon"></i>
                        <span>导出</span>
                    </button>

                    <button class="butStyle greenBtn importBtn" @click="showImportDialog">
                        <i class="importIcon"></i>
                        <span>导入</span>
                    </button>
                </span>
            </div>

            <el-table :data="tableData"
                      style="width: 100%;"
                      border
                      fit
                      highlight-current-row
                      tooltip-effect="dark"
            >
                <el-table-column label="分账ID" prop="code" min-width="140" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="分销标识" prop="configNames" min-width="88" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="分账对象" prop="memberName" min-width="110" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="手机号" prop="phoneNumber" min-width="108" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="用户" prop="userMemberName" min-width="78" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="网点" prop="website" min-width="100" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="激活时间" prop="activeTime" min-width="151" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="当月话费(元)" prop="billFee" min-width="101" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="orangeT">
                            {{scope.row.billFee}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="实际分账金额(元)" prop="commission" min-width="129" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="orangeT">
                            {{(scope.row.commission).toFixed(2)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="分账方式" prop="settlementType" min-width="78" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <!-- <el-table-column label="状态" prop="status" min-width="72" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column> -->
                <el-table-column label="导入时间" prop="importTime" min-width="151" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="处理时间" prop="processingTime" min-width="151" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="最新稽核时间" prop="auditTime" min-width="151" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="170" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="goDetailPage(scope)"
                                   class="greenText"
                                   icon="el-icon-search"
                                   type="text"
                                   title="详情">详情
                        </el-button>
                        <el-button @click="goDetailPage(scope)"
                                   class="greenText"
                                   icon="el-icon-document"
                                   type="text"
                                   title="稽核">稽核
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pageBox boxs">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="searchForm.current" :page-sizes="[10, 20, 30]" 
                            :page-size="searchForm.size"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>



        <!-- 导入弹窗-start -->
        <el-dialog width="400px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
                :before-close="beforeClose" :close-on-click-modal=false :show-close="true">
            <el-form ref="form" :rules="rules" :model="postForm" label-width="92px" style="position:relative;">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="上传文件：" prop="fieldId">
                                <el-upload
                                        action=""
                                        :show-file-list="false"
                                        :before-upload="beforeUpload"
                                        :on-success="handleUploadSuccess"
                                        :on-error="handleUploadError"
                                        :http-request="onUpload"
                                >
                                    <template>
                                        <el-button size="small" class="uploadBtn">
                                            <span>请上传文件</span>
                                            <i class="el-icon-upload el-icon--right"></i>
                                        </el-button>
                                        <span slot="tip" class="uploadTip">
                                            只能上传excel式文件
                                        </span>
                                    </template>
                                </el-upload>
                                <a @click="downloadTemplate" class="uploadTemplate">点击下载模板</a>
                            </el-form-item>
                        </el-col>
                    </el-row>
            </el-form>

            <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeClose" class="butStyle cancelBtn">退 出</button>
                    <!-- <button @click="validateForm" class="butStyle refuseOBtn">保 存</button> -->
                </div>
            </span>
        </el-dialog>
        <!-- 导入弹窗-end -->

    </div>
</template>

<script>
    import SrFilter from '@/components/Common/Filter/Filter';
    import {objectToQueryString} from '@/utils/commonUtils.js';
    import {formatDate} from '@/utils/dateFormatter';
    import {
        getPhoneFeeListAPI, // 查询话费账单明细列表
        getSumCountAndCommissionAPI, //查询佣金总和和记录总数
        // phoneFeeExportAPI, //查询话费明细列表导出
        importPhoneFeeReq, // 话费导入
    } from '@/api/Operate/SplitBillManage/phoneFee.js';

    //获取当前日期的上个月份
    let getLastMonth = function() {
        let date = new Date();
        date.setMonth(new Date().getMonth()-1)
        return formatDate(date, 'yyyy-MM');
    }
    
    //获取当前日期的月份
    let getCurrMonth = function() {
        let date = new Date();
        date.setMonth(new Date().getMonth())
        return formatDate(date, 'yyyy-MM');
    }
    

    // 导入弹窗的数据
    const defaultPostForm = {
        // operate: '1', //运营商
        fieldId: null, //文件id
    }

    // 搜索表格的条件
    const searchConst = {
        params: {
            code: null,// 分账ID
            memberName: null,// 分账对象
            // status: null,// 状态
            // month: getLastMonth(),// 年月
            month: getCurrMonth(),// 年月
        },
        current: 1, //当前页码
        size: 10, //每页条数
    }

    export default {
        name: "phoneFeeIndex",
        data() {
            return {
                timeRange: null,
                //标题
                topTitle: {
                    title: '分账管理',
                    subTit: '话费账单',
                    thirdTit: '',
                },
                // 表格搜索条件
                searchForm: Object.assign({}, searchConst),
                // // 状态
                // statusOptions: [
                //     { id: '0', status:'待审核' },
                //     { id: '1', status:'已同意' },
                //     { id: '2', status:'已拒绝' }
                // ],
                // 表格显示年
                showYear: new Date().getFullYear(),
                // 表格显示月
                showMonth: new Date().getMonth()+1,
                // 表格的月份统计
                monthTotal: {
                    actualTotal: '-', //实际分账：- 元
                    actualCount: '-', //实际分账：- 笔
                    cumulativeTotal: '-', //累计分账：- 元
                    cumulativeCount: '-' //累计分账：- 笔
                },
                // 表格数据
                tableData: [],
                // 表格数据总数
                total: 0,


                // 导入弹窗数据
                postForm: Object.assign({}, defaultPostForm),
                // 添加/编辑窗口是否显示
                dialogFormVisible: false,
                // 弹窗标题
                dialogMap: {
                    import: '话费导入',
                },
                dialogTitle: '',
                // 弹窗校验规则
                rules: {
                    fieldId: [{required: true, message: '请上传文件', trigger: 'blur'}],
                },

            }
        },
        components: {
            SrFilter
        },
        created() {
            // 查询话费账单明细列表
            this.getPhoneFeeList();
            // 获取表格的累计统计数据
            this.getAllSumCountAndCommission();
            // 获取表格的月份统计数据
            this.getSumCountAndCommission();
        },
        methods: {
            // 导出
            tableExport() {
                const url = `${this.$baseNewUrl}esaleb-service-commission/dc-phone-bill-record/billRecordListExport?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
                window.open(url, '_blank');
            },
            // 获取表格的累计统计数据(接口不传月份，查询所有累计数据)
            async getAllSumCountAndCommission() {
                try {
                    const result = await getSumCountAndCommissionAPI()
                    this.monthTotal.cumulativeTotal = result.data.totalCommission;
                    this.monthTotal.cumulativeCount = result.data.totalCount;

                    this.monthTotal.cumulativeTotal = (this.monthTotal.cumulativeTotal).toFixed(2);
                } catch (e) {
                    console.log(e)
                }
            },
            // 获取表格的月份统计数据(接口传月份，查询月份数据)
            async getSumCountAndCommission() {
                try {
                    const result = await getSumCountAndCommissionAPI({"month": this.searchForm.params.month})
                    this.monthTotal.actualTotal = result.data.totalCommission;
                    this.monthTotal.actualCount = result.data.totalCount;

                    this.monthTotal.actualTotal = (this.monthTotal.actualTotal).toFixed(2);
                } catch (e) {
                    console.log(e)
                }
            },
            // 获取列表数据
            async getPhoneFeeList() {
                try {
                    const resp = await getPhoneFeeListAPI(this.searchForm)
                    this.tableData = resp.data.records
                    this.total = parseInt(resp.data.total)
                } catch (e) {
                    console.log(e)
                }
            },

            // 列表过滤查询
            handleSearch() {
                this.getPhoneFeeList()
                this.getSumCountAndCommission();
            },
            // 搜索重置（清空）
            handleReset() {
                // 初始化参数
                this.searchForm.params = {}
                // // 重置的年月：获取当前日期的上个月份
                // this.searchForm.params.month = getLastMonth();
                // 重置的年月：获取当前日期的月份
                this.searchForm.params.month = getCurrMonth();
                this.handleSearch()
            },
            // 列表每页条数变了
            handleSizeChange(val) {
                this.searchForm.size = val
                this.getPhoneFeeList()
            },
            // 列表当前页码变了
            handleCurrentChange(val) {
                this.searchForm.current = val
                this.getPhoneFeeList()
            },


            // 年月改变事件-同时改变表格中的显示日期
            yearMonthChange() {
                // 避免清空年月时报错
                if(this.searchForm.params.month) {
                    let splitIndex = this.searchForm.params.month.indexOf('-')
                    this.showYear = this.searchForm.params.month.slice(0, 4);
                    this.showMonth = this.searchForm.params.month.slice(5, 7);
                }
            },
            // 跳转到"话费账单"详情页
            goDetailPage(scope) {
                this.$router.push({
                    path: '/operate/splitBillManage/phoneFeeDetail',
                    query: {
                        phoneNumber: scope.row.phoneNumber,
                        memberId: scope.row.memberId,
                        code: scope.row.code
                    }
                })
            },


            // 弹出导入弹窗
            showImportDialog() {
                this.dialogTitle = 'import'
                this.dialogFormVisible = true
            },

            // 弹窗关闭前
            beforeClose() {
                this.resetData()
            },
            // 关闭弹窗
            closeDialog() {
                this.resetData()
            },
            // 重置表单
            resetData() {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs['form'].clearValidate()
                })
                this.postForm = Object.assign({}, defaultPostForm)
            },

            // 验证表单-点击弹窗的“确定”按钮
            validateForm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitForm()
                    } else {
                        this.dialogFormVisible = true
                    }
                })
            },
            // 提交表单
            async submitForm() {
            },


            // 下载话费导入模板
            async downloadTemplate() {
                try {
                    // const resp = await getPhoneFeeDownloadTemplateReq()
                    // if (!resp || (resp && resp.code != 0)) {
                    //     this.$message.error('下载失败！')
                    //     return
                    // }
                    // let blob = new Blob([resp], {type: 'application/vnd.ms-excel'})
                    // let link = document.createElement('a');
                    // link.href = URL.createObjectURL(blob)
                    // link.download = '话费导入模板'
                    // link.click()
                    const url = `${this.$baseNewUrl}esaleb-service-commission/dc-phone-bill-record/download?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm)}`;
                    window.open(url, '_blank');
                } catch (e) {
                    console.log(e)
                }
            },

            // 话费导入(上传文件)
            onUpload (uploadObj) {
                let file = uploadObj.file
                let param = new FormData()
                param.append('file', file)
                // console.log('uploadObj', uploadObj)

                importPhoneFeeReq(param).then(resp => {
                    if (resp && resp.code != 0) {
                        this.$message.error(resp.msg)
                        return
                    }
                    this.$message.success('话费导入成功')
                    this.closeDialog()
                    this.getPhoneFeeList()
                }).catch(err => {
                    console.log(err)
                })
            },
            // 文件上传成功时的钩子
            handleUploadSuccess(res, file) {
                // console.log('Success-res', res)
                // console.log('Success-file', file)
            },
            // 文件上传失败时的钩子
            handleUploadError(res, file) {
                // console.log('Error-res', res)
                // console.log('Error-file', file)

                this.$message.error('文件上传失败！')
                this.$alert('文件上传失败！', '上传失败提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    showClose: false,
                    dangerouslyUseHTMLString: true
                })
            },
            beforeUpload(file) {
                // console.log(file)
                const isXls = file.type === 'application/vnd.ms-excel';
                const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isXls && !isXlsx) {
                    this.$message.error('只能上传xls/xlsx文件!');
                    // this.$message.error('导入文件只能是 xls 或 xlsx 格式!')
                    // this.$message.error('请上传excel文件!')
                }
                if (!isLt2M) {
                  this.$message.error('文件大小不能超过 2MB!');
                }
                var check = isLt2M && (isXls || isXlsx);
                // console.log(check)
                return check;
            },

        },


    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.greenText {
    color: #2DBAA5;
}
.orangeT {
    color: #FA6241;
}

.phoneFee {

}

// 标题
.phoneFee .titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleBox b {
    color: #2B2727;
    font-size: 15px;
}

.titleBox span {
    color: #7F7F7F;
    font-size: 13px;
}

.titleBox .titRiImg {
    width: 76px;
    height: 24px;
}

// 筛选框
.phoneFee .searchBox {
    margin-top: 1px;
}

// 表格
.phoneFee .botTable {
    margin-top: 12px;
    width: 100%;
}

.botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
}

.botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
}

.botTable .tableTop .top_ri {
    font-size: 12px;
    color: #7F7F7F;
}

.botTable .tableTop .top_ri b {
    font-size: 20px;
    font-weight: normal;
    color: #FFCC00;
}

.botTable .tableTop .top_ri .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
}

.botTable .tableTop .top_ri .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
}

.botTable .tableTop .top_ri .importBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;
    background-color: #2DBAA5;
    &:hover {
      background-color: rgb(126, 187, 178);
    }
}

.botTable .tableTop .top_ri .importBtn .importIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/resource/NumCardManage/importIcon.png') no-repeat;
    background-size: 14px 14px;
}

/* 分页条 */
.pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
}



// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #FFFFFF;
    // background: #FA6241;
    // &:hover {
    //   background-color: rgb(247, 143, 120);
    // }
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}


.uploadBtn {
    font-size: 12px;
    color: #ffffff;
    border: none;
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}
.uploadTip {
//   display: inline;
    font-size: 12px;
    color: #AAAAAA;
    margin-left: 12px;
}
.uploadTemplate {
    display: inline;
    cursor: pointer;
    font-size: 12px;
    color: #2DBAA5;
    text-decoration: none;
}
.uploadTemplate :active {
    color: rgb(134, 189, 180);
}


</style>
